export const getUserFirstName = (state) => state.getIn(['authorization', 'user', 'firstName'])
export const getUserLastName = (state) => state.getIn(['authorization', 'user', 'lastName'])
